<template>
    <b-modal
        id="modal-details-news"
        ref="modal-details-news"
        centered
        ok-only
        ok-title="Cerrar"
        ok-variant="secondary"
        size="lg"
        :title="modalTitle"
        @hidden="resetSelectedNews()"
    >
        <b-card v-if="selectedNewsObject">
            <b-card-text>
                <!-- The contents of this div will render the (pre-sanitized) selectedNewsObject body html -->
                <div v-html="selectedNewsObject.body" />
            </b-card-text>

            <template v-slot:footer>
                <div class="text-right">
                    {{ selectedNewsObject.authorName }} - {{ selectedNewsObject.latestUpdateDate }}
                </div>
            </template>
        </b-card>
    </b-modal>
</template>

<script>

import { mapState } from 'vuex'

export default {
    name: 'NewsDetailsModal',
    computed: {
        ...mapState([
            'selectedNewsObject'
        ]),
        modalTitle () {
            if (this.selectedNewsObject) {
                return this.selectedNewsObject.title
            }
            return ''
        }
    },
    methods: {
        resetSelectedNews () {
            this.$store.commit('RESET_SELECTED_NEWS_OBJECT')
        }
    }
}
</script>

<style scoped>
.p-whitespace {
    white-space: pre-wrap;

}
</style>
